"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function useMultipointStringConvert() {
    const convert = (pointString) => {
        // convert string in format "POINT(x,y)" to LocationPoint
        const point = pointString.replace("MULTIPOINT", "").replace("POINT", "").replace("(", "").replace(")", "").split(" ");
        const x = parseFloat(point[0]);
        const y = parseFloat(point[1]);
        return [x, y];
    };
    return convert;
}
exports.default = useMultipointStringConvert;
;
